import { saleProcessInitialState } from "./saleProcess";
import { BusinessType } from "@/api/constants/enums";
import { CustomerType } from "@/api/models/customer";
import { SaleProcessAddressSearchDto } from "@/api/sale-process";
import { SALE_PROCESS_CLEAR_STATE } from "./constants";

const clear = (state: any) => {
	Object.assign(state, saleProcessInitialState());
};

const updateId = (state: any, id: string) => {
	state.id = id;
};

const updateStatus = (state: any, status: string) => {
	state.status = status;
};

const updateAddressSearch = (state: any, addressSearch: SaleProcessAddressSearchDto) => {
	const { coberturaId, coberturaPisoPortaId } = addressSearch;

	state.sale.addressSearch = addressSearch;
	state.sale.address.id = coberturaId;
	state.sale.apartment.apartmentId = coberturaPisoPortaId;
};

const updateApartmentId = (state: any, id: string) => {
	state.sale.addressSearch = {
		...state.sale.addressSearch,
		coberturaPisoPortaId: id
	};

	state.sale.apartment = {
		apartmentId: id,
		streetType: "",
		streetName: "",
		streetNumber: "",
		floor: "",
		stair: "",
		door: "",
		network: "",
		serviceableStatus: "",
		salesAreaName: "",
		city: "",
		province: ""
	};
};

const updateApartment = (state: any, apartment: any) => {
	if (apartment) {
		state.sale.apartment.apartmentId = apartment.apartmentId ? apartment.apartmentId : apartment.id;
		state.sale.apartment.streetType = apartment.streetType;
		state.sale.apartment.streetName = apartment.streetName;
		state.sale.apartment.streetNumber = apartment.streetNumber;
		state.sale.apartment.floor = apartment.floor;
		state.sale.apartment.stair = apartment.stair;
		state.sale.apartment.door = apartment.door;
		state.sale.apartment.network = apartment.network;
		state.sale.apartment.serviceableStatus = apartment.serviceableStatus;
		state.sale.apartment.salesAreaName = apartment.salesAreaName;
		state.sale.apartment.city = apartment.city;
		state.sale.apartment.province = apartment.province;
	} else {
		state.sale.apartment = {
			apartmentId: "-1",
			streetType: "",
			streetName: "",
			streetNumber: "",
			floor: "",
			stair: "",
			door: "",
			network: "",
			serviceableStatus: "",
			salesAreaName: "",
			city: "",
			province: ""
		};
	}
};

const updateSelectedBundle = (state: any, bundle: string) => {
	state.sale.selectedBundle = bundle;
};

const updateCustomer = (state: any, saleProcess: any) => {
	state.sale.customer.customerType = saleProcess.customer.customerType;
	if (saleProcess.customer.customerType === CustomerType.BUSINESS && saleProcess?.businessInfo.companyType !== BusinessType.INDIVIDUAL) {
		state.sale.customer.type = saleProcess.businessInfo.identification?.type;
		state.sale.customer.number = saleProcess.businessInfo.identification?.number;
		state.sale.customer.country = saleProcess.businessInfo.identification?.country;
		state.sale.customer.companyType = saleProcess.businessInfo.companyType;
	} else {
		state.sale.customer.type = saleProcess.customer.identification?.type;
		state.sale.customer.number = saleProcess.customer.identification?.number;
		state.sale.customer.country = saleProcess.customer.identification?.country;
		state.sale.customer.companyType = saleProcess.businessInfo ? saleProcess.businessInfo.companyType : "";
	}
};

const clearCustomer = (state: any) => {
	state.sale.customer = {
		customerType: "",
		type: "",
		number: "",
		country: "",
		companyType: ""
	};
};

export default {
	clearCustomer,
	[SALE_PROCESS_CLEAR_STATE]: clear,
	updateAddressSearch,
	updateApartment,
	updateApartmentId,
	updateCustomer,
	updateId,
	updateSelectedBundle,
	updateStatus
};
